import Marquee from "react-fast-marquee";

const ITEMS = [
  "Performance",
  "Gaming",
  "Price & Value",
  "Software Ecosystem",
  "Creative Work",
  "Longevity",
];

const MarqueeBand = () => (
  <div className="border-y border-white/10 py-5 bg-[#0A0A0A]" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="marquee-item text-lg text-[#A1A1AA] px-8">{item}</span>
          <span className="text-[#0055FF] text-xs">◆</span>
          <span className="marquee-item text-lg text-stroke px-8">Windows vs Mac</span>
          <span className="text-[#FF3300] text-xs">◆</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default MarqueeBand;
